/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalRgAnalysisViewModel } from "../types/PersonDocumentApprovalRgAnalysisViewModel.ts";

export const personDocumentApprovalRgAnalysisViewModelSchema = z.object({
  personName: z.string().describe("Nome extraído do RG. Opcional.").nullish(),
  rgNumber: z.string().describe("Número do RG extraído. Opcional.").nullish(),
  cpfNumber: z.string().describe("Número do CPF extraído. Opcional.").nullish(),
  birthDate: z
    .string()
    .datetime()
    .describe("Data de nascimento extraída. Opcional.")
    .nullish(),
  shippingDate: z
    .string()
    .datetime()
    .describe("Data de expedição extraída. Opcional.")
    .nullish(),
  mothersName: z.string().describe("Nome da mãe extraído. Opcional.").nullish(),
  fathersName: z.string().describe("Nome do pai extraído. Opcional.").nullish(),
  hasAnyInformation: z.optional(
    z.boolean().describe("Indica se ao menos um campo foi extraído do RG."),
  ),
}) as unknown as ToZod<PersonDocumentApprovalRgAnalysisViewModel>;
